module.exports = __webpack_public_path__ + "assets/bed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bed.svg
// module id = 1182
// module chunks = 7